// extracted by mini-css-extract-plugin
export default {"container":"MenuList_container__8V4kL","tooltip":"MenuList_tooltip__e90y8","divider":"MenuList_divider__uL-9x"};